module.exports = __webpack_public_path__ + "img/background_17.a619c601.jpg";